import { render, staticRenderFns } from "./aCarDetailTransactionCar.vue?vue&type=template&id=95e6b664&scoped=true"
import script from "./aCarDetailTransactionCar.vue?vue&type=script&lang=js"
export * from "./aCarDetailTransactionCar.vue?vue&type=script&lang=js"
import style0 from "./aCarDetailTransactionCar.vue?vue&type=style&index=0&id=95e6b664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e6b664",
  null
  
)

export default component.exports